import posthog from "posthog-js"

const POSTHOG_KEY = import.meta.env.VITE_POSTHOG_KEY as string | undefined
const POSTHOG_HOST =
  (import.meta.env.VITE_POSTHOG_HOST as string | undefined) ??
  "https://eu.i.posthog.com"

function analyticsEnabled() {
  return Boolean(POSTHOG_KEY) && import.meta.env.MODE === "production"
}

export function initAnalytics() {
  if (!analyticsEnabled() || posthog.__loaded) return
  posthog.init(POSTHOG_KEY!, {
    api_host: POSTHOG_HOST,
    capture_pageview: false,
    capture_pageleave: true,
    person_profiles: "identified_only",
    disable_session_recording: true,
    persistence: "memory",
  })
}

export { posthog }
